import { exists } from "fs";


export const report = (chartHm, chartEffiency, chartNpshr, chartPumpPower,
	dutyPoint, unit_flow, unit_head, pump, motor, dimensionsImage) => {
 
		var svgFit = [580, 150]
  
		if ( motor.length < 1){
			console.log("motor bos")
			if (pump.frequency == 50)
			var rpm = 2900
			else
			var rpm = 3450 
			
			motor = { rpm: rpm, voltage: pump.voltage, eff100: "" }
		} else {
			motor = dutyPoint.selected_voltage_data
		}

		if (unit_flow == "m3_h")
			unit_flow = "m\u00B3/h"
		 if (unit_flow == "gpm")
			unit_flow = "GPM"
			else if (unit_flow == "l_sec")
			unit_flow = "l/sec"
			else if (unit_flow == "l_min")
			unit_flow = "l/min"

		// unit_flow = ""

		var svgWidth = 530
		var svgHeight = 265

	
	var logoBase64 = "maxisu/logo.png"
	var dimensionImageBase64 = "maxisu/dimensions.png"

	// console.log(chartHm)

	// playground requires you to assign document definition to a variable called dd

	var dd = {
		pageMargins: [ 20, 20, 20, 10 ],
		content: [
			//http://www.maxisu.com/images/logo.png

			{
				
				table: {
					widths: [170, '*', 150],

					body: [
						[{
							margin: 10,
							width: 150,
							image: logoBase64,
							border:[true,true,false,false]
						},
						{
							alignment: 'center',
							text: myvue.$t('report.pump_performance_curve'), margin: 10,
							border:[true,true,false,false]
						},

						{
							text: myvue.$t('report.pump_type')+' : ' + pump.pump_type + ' / ' + pump.stage +
								' - ' + pump.frequency + 'Hz', fontSize: '10', alignment: 'right', margin: [5, 10],

							border:[true,true,true,false]
						}
						],






					]
				},


			},

			{
				style: 'content',

				table: {
					widths: ['*', '*', '*', '*', '*'],
					body: [

						[
							'Q: ' + dutyPoint.q + " " + unit_flow

							// {
							// 	columns: [
							// 		{text: 'line 2 before superscript', width: 'auto'},
							// 		{text: 'superscript', width: 'auto', fontSize: 8},
							// 		{text: 'line 2 after superscript', width: 'auto'}
							// 	]
							// }


							
							, 'H: ' + dutyPoint.hm + " " + unit_head,
						'Nep: ' + dutyPoint.p2 + " kW", myvue.$t('pump.efficiency')+': ' + dutyPoint.effiency + " %",
						'RPM : ' + motor.rpm],



						//[ { colSpan:7, text:'bbb'} , {text:'Motor Model: '} ],

						[
							{ colSpan: 1, alignment: 'left', text: myvue.$t('motor.motor_type')+': ' + pump.motor_type },
							{ colSpan: 4, alignment: 'left', text: myvue.$t('motor.power')+': ' + pump.motor_power + ' HP' },

							//{colSpan: 6, text:'Motor Model: '} 
						],


						[{ colSpan: 5, fontSize: 7, text: myvue.$t('report.iso9906') },
						],








					]
				},


			},
			{ text: " " },

			// {
			// 	table: {
			// 		widths: ['*'],
			// 		body: [
			// 			[

			// 			],
						
			// 		]
			// 	}
			// },

			{
				alignment: "center",
				width:600,
				height:150,
				// fit: [600, 150],
				// fit: svgFit ,
				svg: chartHm
			},
			{ text: " " },

			{
				alignment: "center",
				// width:svgWidth,
				// height:svgHeight,
				fit: svgFit,
				svg: chartEffiency
			},

			{ text: " " },

			{
				alignment: "center",
				// width:svgWidth,
				// height:svgHeight,
				fit: svgFit,
				svg: chartNpshr
			},

			{ text: " " },

			{
				alignment: "center",
				fit: svgFit,
				svg: chartPumpPower
			},


			{
				pageBreak: 'before',
				table: {
					widths: [170, '*', 150],

					body: [
						[{
							width: 150, margin: 10,
							image: logoBase64
						},
						{
							alignment: 'center',
							text: myvue.$t('report.technical_specification'), margin: 10
						},

						{
							text: myvue.$t('pump.pump_type')+' : ' + pump.pump_type + ' / ' + pump.stage +
								' - ' + pump.frequency + 'Hz', fontSize: '10', alignment: 'right', margin: [5, 10]
						}
						],






					]
				},



			},

			{

				style: 'content',

				table: {
					widths: ['*', 150, 150],
					body: [

						[{text:' ', border:[true,false,false,false]},
						{text:' ', border:[false,false,false,false]},
						{text:' ', border:[false,false,true,false]}],
						[
							
							{ 
								alignment: 'center',
								border:[true,false,false,false], 
								rowSpan: 39, height: 500, width: 100, image: dimensionImageBase64 
							}
 
							// {
							// 	alignment: "center", 
							// 	border:[true,false,false,false], 
							// 	// width:250,
							// 	// height:150,
							// 	rowSpan: 39, 
							// 	// height: 484, width: 300,
							// 	// fit: [100, 484],
							// 	// fit: svgFit ,
							// 	svg: dimensionsImage
							// } 
 
							, 
							{ colSpan: 2, text: myvue.$t('report.pump_features') },
							''
						],
						
						['', myvue.$t('pump.type')+': ', pump.pump_type],
						['', myvue.$t('pump.stage')+': ', pump.stage],
						['', myvue.$t('pump.material')+': ', pump.material],
						['', myvue.$t('pump.flow')+': ', dutyPoint.q + ' ' + unit_flow],
						['', myvue.$t('pump.head')+': ', dutyPoint.hm + ' ' + unit_head],
						['', 'RPM: ', motor.rpm],
						['', myvue.$t('report.curve_tolerance')+': ', 'ISO 9906 Grade 3B'],
						['', 'Φ R: ', pump.fi_r + " mm"],
						['', 'Φ E: ', pump.fi_e +'"'],

						['', myvue.$t('pump.impeller')+': ', pump.impeller],
						['', myvue.$t('pump.pump_shaft')+': ', pump.pump_shaft],
						['', myvue.$t('pump.coupling')+': ', pump.coupling],
						['', myvue.$t('pump.strainer')+': ', pump.strainer],

						[
							' ',
							{
								colSpan:2,
								border:[false,false,true,false], 
								text:' '}
						],

						['', { colSpan: 2, text: myvue.$t('report.motor_features') }],

						['', myvue.$t('motor.type')+': ', pump.motor_type],
						['', myvue.$t('motor.diameter')+' (ΦD): ', pump.motor_diameter + ' mm'],
						['', myvue.$t('motor.power')+': ', pump.motor_power
							+ ' HP (' + (pump.motor_power * 0.7457).toFixed(2) + ' kW)'],
						['', myvue.$t('motor.voltage')+': ', motor.voltage +' V'],
						['', myvue.$t('motor.nominal_current')+': ', pump.nominal_current +' A'],
						['', myvue.$t('pump.frequency')+': ', pump.frequency+ ' Hz'],

						['', myvue.$t('motor.start')+': ', pump.starting],
						['', 'RPM: ', motor.rpm],
						['', myvue.$t('motor.protection_degree')+': ', 'IP 68'],
						['', myvue.$t('motor.seal_type')+': ', 'Mechanical Seal'],
						['', myvue.$t('motor.flange')+': ', 'NEMA'],
						// ['', 'Cosfi: ', pump.fi_r + " mmaaa"],  

						// ['', 'Cosφ: ', ( parseFloat(dutyPoint.motor_cosfi) /100).toFixed(2) ], 
						['', 'Cosφ: ', motor.cosfi100 ], 
						
						['', myvue.$t('motor.effieciency')+': ', motor.eff100 +'%'],

						[
								
								' ',
								{
									colSpan:2,
									border:[false,false,true,false], 
									text:' '}
							 
						],

						['', { colSpan: 2, text: myvue.$t('report.scales_weights') }],

						['', myvue.$t('pump.length')+': ', pump.lp +' mm'],
						['', myvue.$t('motor.length')+': ', pump.motor_length+' mm'],
						['', myvue.$t('report.moto_pump_length')+': ',
							(parseFloat(pump.motor_length) + parseFloat(pump.lp))+' mm'
						],
						['', myvue.$t('pump.diameter')+': ', pump.fi_r +' mm'],
						['', myvue.$t('motor.diameter')+' (ΦD): ', pump.motor_diameter+ ' mm'],
						['', myvue.$t('pump.weight')+': ', pump.pump_weight +' kg'],
						['', myvue.$t('motor.weight')+': ', pump.motor_weight+ ' kg'],
						['', myvue.$t('report.total_weight')+': ',
							(parseFloat(pump.pump_weight) + parseFloat(pump.motor_weight) + ' kg')
						],
						[ {border:[true,false,false,false], 
							text:' '}, {border:[false,false,false,false], 
								text:' '}, {border:[false,false,true,false], 
									text:' '}]

					]

				}
			},

			{

				style: 'content',
				table: {
					widths: ['*'],

					body: [
						[
							myvue.$t('report.right_to_amend')
						],


					]
				},


			},
 
			 
			 
			 
		],
		styles: {
			content: {
				fontSize: 10,
			},
			header: {
				fontSize: 18,
				bold: true,
				margin: [0, 0, 0, 10]
			},
			subheader: {
				fontSize: 16,
				bold: true,
				margin: [0, 10, 0, 5]
			},
			tableExample: {
				margin: [0, 5, 0, 15]
			},
			tableHeader: {
				bold: true,
				fontSize: 13,
				color: 'black'
			}
		},
		defaultStyle: {
			// alignment: 'justify'
		}

	}

	console.log(dd)


	return dd;
}

export const dimensionsImageBase64 = () => { return "data:image/png;base64,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" }
